export enum ByproductFieldType {
  LeftInTheField = 'LeftInTheField',
  Harvested = 'Harvested'
}
